"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { FileCheck, Users, ClipboardList, HeartHandshake, Shield } from "lucide-react";
export default function ServiceListings() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref4,
    isVisible: isVisible4
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref5,
    isVisible: isVisible5
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref6,
    isVisible: isVisible6
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: ref7,
    isVisible: isVisible7
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const services = [{
    icon: FileCheck,
    title: "Billing & Claims Submission",
    description: "Accurate and timely billing support tailored for ABA providers, ensuring compliance and efficient revenue cycle management.",
    delay: "0ms"
  }, {
    icon: Users,
    title: "Provider Credentialing Support",
    description: "Streamlined credentialing processes to help providers enroll with insurance networks quickly and accurately. Get your providers in-network faster.",
    delay: "150ms"
  }, {
    icon: ClipboardList,
    title: "Claims Follow-Up and Denial Support",
    description: "Proactive claims tracking and denial management to maximize reimbursements and reduce administrative burden.",
    delay: "300ms"
  }, {
    icon: HeartHandshake,
    title: "Practice Administrative Support",
    description: "Comprehensive operational support to enhance practice efficiency and allow providers to focus on patient care. Back-office support so you can run your practice with peace of mind.",
    delay: "450ms"
  }, {
    icon: Shield,
    title: "Insurance Verification",
    description: "Fast turnaround so you can schedule with confidence.",
    delay: "600ms"
  }, {
    icon: Shield,
    title: "Authorizations",
    description: "Initial & ongoing authorization requests and tracking.",
    delay: "750ms"
  }, {
    icon: Shield,
    title: "Payroll Management Support",
    description: "For an easy and on-time payroll processing.",
    delay: "900ms"
  }];
  const refs = [ref1, ref2, ref3, ref4, ref5, ref6, ref7];
  const visibilities = [isVisible1, isVisible2, isVisible3, isVisible4, isVisible5, isVisible6, isVisible7];
  return <section id="service-listings" className="py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-6xl">
        <div className="mb-12 text-center">
          <h2 className="text-3xl font-display font-semibold tracking-tight text-foreground mb-4">
            Our Services
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Specialized administrative support designed for ABA and behavioral health providers
          </p>
        </div>

        <div className="grid gap-6 md:gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} ref={refs[i]} className={`transition-all duration-150 ease-out ${visibilities[i] ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"} ${i % 2 === 0 ? "md:mr-12" : "md:ml-12"}`} style={{
            transitionDelay: visibilities[i] ? service.delay : "0ms"
          }}>
                <Card className="group hover:shadow-strong transition-all duration-150 ease-out hover:-translate-y-1">
                  <CardHeader>
                    <div className="flex items-start gap-4">
                      <div className="shrink-0 p-3 bg-primary-light rounded-md group-hover:scale-102 transition-transform duration-150">
                        <Icon className="size-6 text-primary" strokeWidth={1.5} />
                      </div>
                      <div className="flex-1">
                        <CardTitle className="text-xl mb-2">{service.title}</CardTitle>
                        <CardDescription className="text-base leading-relaxed">
                          {service.description}
                        </CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent>
                    <Link to="#" className="inline-flex items-center text-primary font-medium hover:text-primary-hover transition-colors duration-150">
                      Learn More
                      <svg className="ml-2 size-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}